export function throttle(fn: () => void, delay: number) {
  let isThr = false;

  return function (...args: any) {
    if (!isThr) {
      fn.apply(this, args);
      isThr = true;

      setTimeout(() => {
        isThr = false;
      }, delay);
    }
  };
}
